<div class="container my-5">
    <div class="rounded shadow p-3 primaryBgColor text-dark">
        <h3 class="my-2">Willkommen beim Ferienpass der Gemeinde Handewitt!</h3>

        <p>
            Durchgeführt vom <b>Trägerverein offene Jugendarbeit e.V.</b>, im Folgenden <b>T.o.J.</b> genannt.
            Über diese Plattform können Sie Ihre Kinder für verschiedene Aktionen aus dem Ferienpass-Programm anmelden.
            Im
            Folgenden erklären wir Ihnen den Ablauf Schritt für Schritt.

        </p>
    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h4 class="my-2">Registrierung & Anmeldung</h4>
        <p>
            Falls Sie noch keinen Account haben, <a routerLink="/registration">registrieren</a> Sie sich bitte zunächst.<br>
            <b>Wichtig:</b> Alle Accounts aus dem Vorjahr wurden gelöscht!<br><br>
            Nach der Registrierung erhalten Sie eine E-Mail mit einem Bestätigungslink. Erst nach Klick auf diesen Link
            ist
            Ihr Account aktiviert.
            <br><br>
            Melden Sie sich anschließend über die Anmeldeseite im System an. Sollten Sie Ihr Passwort vergessen haben,
            können Sie es einfach über die „Passwort vergessen“-Funktion zurücksetzen.
            <br><br>
            Nach dem Login können Sie unter „<a routerLink="/settings/elternList">Einstellungen</a>“ Ihre Kinder über
            das
            <b>Plus-Symbol</b> neben Ihrem Namen anlegen.
            Falls Sie <b>soziale</b> Unterstützung erhalten (z. B. Bildungskarte oder Transferleistungen), können Sie
            die
            entsprechenden Angaben direkt beim jeweiligen Kind eintragen und die Bildungskarte hochladen.

        </p>
    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h4 class="my-2">Aktionen buchen – so funktioniert’s</h4>
        <p>
            Nach dem Anlegen Ihrer Kinder können Sie unter dem Menüpunkt „<a routerLink="/anmelden">Kinder-Anmelden</a>“
            Aktionen aus dem Ferienpass-Programm auswählen. Der Ablauf gliedert sich in folgende Phasen:
        </p>
        <h5>1. Voranmeldung</h5>
        <p>Bis zum {{ anmeldungenDatum | datum }} um {{ anmeldungenDatum | zeit }} Uhr können Sie Ihre Kinder
            unverbindlich
            für Aktionen voranmelden.<br>
            Das ist lediglich eine <b>Vorauswahl</b> – Ihre Kinder sind zu diesem Zeitpunkt noch <b>nicht verbindlich
                angemeldet.</b></p>

        <h5>2. Anmeldung</h5>
        <p>Ab dem genannten Datum ({{ anmeldungenDatum | datum }}, {{ anmeldungenDatum | zeit }}Uhr) können Sie Ihre
            Voranmeldungen aktivieren. Gehen Sie dazu auf die
            jeweilige Aktionsseite und klicken Sie auf „<a routerLink="/anmelden">Kinder-Anmelden</a>“. Alle
            gespeicherten
            Voranmeldungen werden dadurch
            in <b>verbindliche Anmeldungen</b> umgewandelt. Diese Anmeldungen werden dem T.o.J.-Team in chronologischer
            Reihenfolge
            zur Bearbeitung vorgelegt.</p>

        <h5>3. Buchung</h5>
        <p>Das T.o.J.-Team prüft alle Anmeldungen und vergibt die Plätze. Sobald eine Aktion für Ihr Kind gebucht ist,
            erhalten Sie eine <b>Buchungsbestätigung per E-Mail</b>.
            Darin enthalten ist auch eine <b>Übersicht sowie der zu zahlende Betrag</b>, den Sie bitte <b>innerhalb von
                3
                Werktagen</b>
            überweisen. Nicht rechtzeitig bezahlte Buchungen können storniert und der Platz an ein anderes Kind vergeben
            werden.</p>

        <h5>4. Warteliste</h5>
        <p>Wenn eine Aktion bereits ausgebucht ist, kann Ihr Kind auf die <b>Warteliste</b> gesetzt werden. Wird ein
            Platz
            frei,
            rückt das nächste Kind auf der Liste automatisch nach.
        </p>
    </div>
    <div class="rounded shadow p-3 primaryBgColor text-dark my-4">
        <h4 class="my-2">Kontakt</h4>
        <p>
            Bei Fragen erreichen Sie uns über:<br>
            <b>WhatsApp:</b> 04608 972 0960<br>
            <b>E-Mail:</b> <a href="mailto:ferienpass@toj-online.de">ferienpass@toj-online.de</a><br>
            Bitte haben Sie dafür Verständnis, dass wir im laufenden Ferienpass nicht ans Telefon gehen und auch keine
            E-Mails beantworten können.
        </p>
    </div>

</div>
